import type { ExternalTableSchema } from '@packages/table-builder';

export const valuationsTable: ExternalTableSchema = {
  metadata: {
    title: 'Valuations',
    entity: 'Valuation',
    description: 'Add and manage valuation records for cap table analysis.',
  },

  dataSource: {
    endpoint: '/api/cap-table/api/app/valuation',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
    },
  },

  columns: [
    {
      field: 'valuationDate',
      header: 'Valuation Date',
      type: 'date',
      width: 150,
      sortable: true,
      visibility: 'locked',
    },
    {
      field: 'pricePerShare',
      header: 'Price / Share',
      type: 'currency',
      format: { decimals: 6 },
      width: 140,
      sortable: true,
      align: 'right',
    },
    {
      field: 'provider',
      header: 'Provider',
      type: 'text',
      width: 180,
      sortable: true,
    },
    {
      field: 'expiresOn',
      header: 'Expires On',
      type: 'date',
      width: 140,
      sortable: true,
    },
    {
      field: 'boardApprovalDate',
      header: 'Board Approval Date',
      type: 'date',
      width: 170,
      sortable: true,
    },
    {
      field: 'stockClassName',
      header: 'Stock Class',
      type: 'text',
      width: 160,
      sortable: true,
    },

    // ── Column-picker only ──────────────────────────────────────────
    {
      field: 'creationTime',
      header: 'Created At',
      type: 'date',
      width: 150,
      sortable: true,
      visibility: 'picker',
    },
    {
      field: 'lastModificationTime',
      header: 'Last Modified',
      type: 'date',
      width: 150,
      sortable: true,
      visibility: 'picker',
    },
  ],

  actions: {
    row: [
      { id: 'VIEW_VALUATION', label: 'View' },
      { id: 'EDIT_VALUATION', label: 'Edit' },
      { id: 'DELETE_VALUATION', label: 'Delete', variant: 'danger' },
    ],
    toolbar: {
      primary: {
        id: 'ADD_VALUATION',
        label: 'Add Valuation',
        icon: 'add_circle_outline',
      },
    },
  },

  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    columnPreferences: { persistenceKey: 'Valuation', resizable: true, reorderable: true },
  },
};
